let $ = require('jquery'),
  Core = require('../Core/Core');

let ContactPage = (function() {
  $('.driving-directions-btn').click(function(e) {
    e.preventDefault();

    Core.modal('.driving-directions');
  });
})();


// WEBPACK FOOTER //
// ./htdocs/content/themes/tpt-national/assets/js/modules/ContactPage/ContactPage.js